import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { StoryPreview } from '@/components/StoryPreview';
import type { StoryTemplate, GeneratedStorySpreadWithImageUrl } from 'schemas';
import { storyPreviewModalMessages } from './storyPreviewModal.messages';

interface StoryPreviewModalProps {
  storyTemplate: StoryTemplate | null;
  isOpen: boolean;
  onClose: () => void;
}

export function StoryPreviewModal({
  storyTemplate,
  isOpen,
  onClose,
}: StoryPreviewModalProps) {
  if (!storyTemplate || !storyTemplate.spreads) {
    return null;
  }

  // Transform StorySpread to GeneratedStorySpreadWithImageUrl for the preview component
  const spreadsWithImageUrls: GeneratedStorySpreadWithImageUrl[] =
    storyTemplate.spreads.map((spread) => ({
      ...spread,
      spread_text_generation_status: 'NOT_STARTED',
      spread_image_generation_status: 'NOT_STARTED',
      imageUrl: undefined, // No images available for story templates yet
    }));

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="h-[90vh] overflow-y-auto p-4 sm:max-w-[90vw] lg:max-w-[50vw]">
        <DialogTitle className="sr-only">
          {storyPreviewModalMessages.dialogTitle(storyTemplate.title)}
        </DialogTitle>
        <DialogDescription className="sr-only">
          {storyPreviewModalMessages.dialogDescription(
            storyTemplate.title,
            storyTemplate.spreads.length
          )}
        </DialogDescription>
        <StoryPreview
          title={storyTemplate.title}
          spreads={spreadsWithImageUrls}
        />
      </DialogContent>
    </Dialog>
  );
}
